import React, { useRef, useState } from 'react';

import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import HookForm from '../HookForm/HookForm';
import LoaderInline from '../Loader/LoaderInline';
import Datepicker from '../Inputs/Datepicker/Datepicker';
import SelectClientID from '../Selects/SelectClientD';
import SelectClientIssuer from '../Selects/SelectClientDocumentType';
import ClientCreatePkb from '../../pages/Client/NewClient/ClientCreatePkb/ClientCreatePkb';
import ClientCreate from '../../pages/Client/NewClient/ClientCreate/ClientClreate';
import ClientFcbDocument from '../../pages/Client/ClientMainData/ClientFcbDocument/ClientFcbDocument';
import getClients from '../../api/clients/getClients';
import editClientDocuments from '../../api/clients/editClientDocuments';
import alert from '../../helpers/alert';
import { colors } from '../../constants/colors';
import { CLIENT_DOCUMENT_TYPE } from '../../constants';
import { resolveIssuer } from '../../utils/documentIssuer';
import { isDocumentComplete } from '../../utils/clientDocument';

// ÐÐµÑÐºÐ° ÐºÐ°Ðº Ð² SelectClients â ÑÑÐ¾Ð±Ñ ÑÐ¾Ð·Ð´Ð°Ð½Ð½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ Ð²ÑÐ³Ð»ÑÐ´ÐµÐ» Ð² ÑÐµÐ»ÐµÐºÑÐµ ÑÐ°Ðº Ð¶Ðµ,
// ÐºÐ°Ðº Ð¿Ð¾Ð´Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÐµ Ñ Ð±ÑÐºÐ°.
const toOption = (client) => ({
  value: client?.id,
  label: `${client?.name} ${client?.surname}` + (client?.iin ? ` (ÐÐÐ: ${client.iin})` : ''),
  client,
});

const linkStyle = {
  display: 'inline-block',
  color: colors.cameo,
  textDecoration: 'underline',
  cursor: 'pointer',
};

const fetchClient = (clientId) =>
  getClients({ id: clientId }).then((res) => res?.data?.users?.[0] || null);

const buildDocumentInputs = (client) => [
  {
    component: SelectClientID,
    name: 'document_type_id',
    rules: { required: true },
    defaultValue: CLIENT_DOCUMENT_TYPE.find((item) => item.value === client?.document?.document_type_id),
  },
  {
    name: 'document_number',
    label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    rules: { required: true },
    defaultValue: client?.document?.document_number,
  },
  {
    component: SelectClientIssuer,
    name: 'document_issuer',
    label: 'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½',
    rules: { required: true },
    defaultValue: resolveIssuer(client?.document?.document_issuer),
  },
  {
    component: Datepicker,
    name: 'document_date',
    type: 'date',
    label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    rules: { required: true },
    defaultValue: client?.document?.document_date,
  },
  {
    component: Datepicker,
    name: 'document_date_end',
    type: 'date',
    label: 'Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    rules: { required: true },
    defaultValue: client?.document?.document_date_end,
  },
];

/**
 * ÐÐ¾Ð´Ð°Ð»ÐºÐ° Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°Â» â ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°, Ð½Ðµ ÑÑÐ¾Ð´Ñ Ñ ÑÐµÐºÑÑÐµÐ³Ð¾ ÑÐºÑÐ°Ð½Ð°.
 * ÐÑÐºÑÑÐ²Ð°ÐµÑÑÑ Ð½Ð° Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ Ñ eGov (ÐÐÐ Ð¤Ð), Ð¾ÑÑÑÐ´Ð° ÐµÑÑÑ ÑÑÑÐ»ÐºÐ° Ð½Ð° ÑÑÑÐ½ÑÑ ÑÐ¾ÑÐ¼Ñ.
 *
 * ÐÐÐ Ð¾ÑÐ´Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÐµÑÑÐ´Ð°Ð½Ð½ÑÐµ Ð¸ Ð°Ð´ÑÐµÑ, Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð² ÐµÑ Ð¾ÑÐ²ÐµÑÐµ Ð½ÐµÑ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ÑÐ»Ðµ
 * ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ ÑÐµÑÐµÐ· eGov Ð¸Ð´ÑÑ Ð²ÑÐ¾ÑÐ¾Ð¹ ÑÐ°Ð³: Ð·Ð°Ð¿ÑÐ¾Ñ ÑÐ¸ÑÑÐ¾Ð²Ð¾Ð³Ð¾ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ (FCB ID OTP,
 * Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð°Ñ Ð¡ÐÐ¡) Ð¸ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð¿Ð¾Ð»ÐµÐ¹ â Ð¿Ð¾Ð´ÑÑÐ½ÑÑÐ¾Ðµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿Ð¾Ð¿ÑÐ°Ð²Ð¸ÑÑ, Ð° ÐµÑÐ»Ð¸
 * Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ, ÑÑÑ Ð¶Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ ÑÑÐºÐ°Ð¼Ð¸. ÐÑÐ»Ð¸ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð¿ÑÐ¸ÑÐ»Ð¾ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼,
 * ÑÐ¾ÑÐ¼Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼ Ð¸ ÐºÐ»Ð¸ÐµÐ½Ñ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ ÑÑÐ°Ð·Ñ. ÐÐ¾ÑÐ»Ðµ ÑÑÑÐ½Ð¾Ð¹ ÑÐ¾ÑÐ¼Ñ ÑÐ°Ð³Ð° Ð½ÐµÑ:
 * Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ ÑÐ°Ð¼ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ¶Ðµ Ð²Ð²ÑÐ».
 *
 * onCreated Ð¿Ð¾Ð»ÑÑÐ°ÐµÑ Ð¾Ð¿ÑÐ¸Ñ Ð´Ð»Ñ ÑÐµÐ»ÐµÐºÑÐ°: { value, label, client }.
 * hideKato / hideLanguage ÑÐ±Ð¸ÑÐ°ÑÑ Ð¸Ð· ÑÑÑÐ½Ð¾Ð¹ ÑÐ¾ÑÐ¼Ñ ÑÐµÐ³Ð¸Ð¾Ð½ Ð¸ ÑÐ·ÑÐº â Ð¸Ñ ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÑÑ
 * ÑÐ¾Ð»ÑÐºÐ¾ Ñ Ð·Ð°ÑÐ¼ÑÐ¸ÐºÐ°, Ð¿ÑÐ¾Ð´Ð°Ð²ÑÑ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¾Ð½Ð¸ Ð½Ðµ Ð½ÑÐ¶Ð½Ñ.
 */
const ClientCreateModal = ({ isOpen, onRequestClose, onCreated, hideKato, hideLanguage }) => {
  const [mode, setMode] = useState('egov');
  const [stage, setStage] = useState('create'); // create | document
  const [created, setCreated] = useState(null);
  // eGov Ð¾ÑÐ´Ð°Ð» ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼: ÑÐ¾ÑÐ¼Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼, Ð¿ÑÐµÐ´Ð»Ð°Ð³Ð°ÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ ÑÐºÐ°Ð½ Ð¸ ÑÐ¾ÑÐ¾.
  const [scanOnly, setScanOnly] = useState(false);
  const [busy, setBusy] = useState(false);
  // Ð¤Ð¾ÑÐ¼Ð° ÑÐ¸ÑÐ°ÐµÑ defaultValues Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð¿ÑÐ¸ Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ÑÐ»Ðµ
  // Ð¿Ð¾Ð´ÑÑÐ³Ð¸Ð²Ð°Ð½Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° Ð¿ÐµÑÐµÑÐ¾Ð·Ð´Ð°ÑÐ¼ ÐµÑ ÑÐµÑÐµÐ· key.
  const [documentVersion, setDocumentVersion] = useState(0);
  const documentFormRef = useRef(null);

  const reset = () => {
    setScanOnly(false);
    setStage('create');
    setCreated(null);
    setDocumentVersion(0);
  };

  // ÐÐ»Ð¸ÐµÐ½Ñ ÑÐ¶Ðµ ÑÐ¾Ð·Ð´Ð°Ð½ Ð½Ð° Ð±ÑÐºÐµ: Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°ÐºÑÑÐ» Ð¼Ð¾Ð´Ð°Ð»ÐºÑ ÐºÑÐµÑÑÐ¸ÐºÐ¾Ð¼,
  // Ð¾ÑÐ´Ð°ÑÐ¼ ÐµÐ³Ð¾ Ð½Ð°Ð²ÐµÑÑ â Ð¸Ð½Ð°ÑÐµ Ð¾Ð½ Ð·Ð°Ð²ÐµÐ´ÑÑ Ð´ÑÐ±Ð»Ñ.
  const closeWithCreated = () => {
    if (created) onCreated(toOption(created));
    reset();
    onRequestClose();
  };

  const finish = async (clientId) => {
    setBusy(true);
    try {
      const client = await fetchClient(clientId);
      onCreated(client ? toOption(client) : { value: clientId, label: `ÐÐ»Ð¸ÐµÐ½Ñ #${clientId}` });
    } catch (e) {
      onCreated({ value: clientId, label: `ÐÐ»Ð¸ÐµÐ½Ñ #${clientId}` });
    } finally {
      setBusy(false);
      reset();
      onRequestClose();
    }
  };

  const handleCreated = async (clientId, withDocumentStep) => {
    if (!clientId) {
      alert.error('ÐÐ»Ð¸ÐµÐ½Ñ ÑÐ¾Ð·Ð´Ð°Ð½, Ð½Ð¾ Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ ÐµÐ³Ð¾ ÐºÐ°ÑÑÐ¾ÑÐºÑ â Ð²ÑÐ±ÐµÑÐ¸ÑÐµ ÐµÐ³Ð¾ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð²ÑÑÑÐ½ÑÑ');
      reset();
      onRequestClose();
      return;
    }

    if (!withDocumentStep) return finish(clientId);

    setBusy(true);
    let client = null;
    try {
      client = await fetchClient(clientId);
    } catch (e) {
      client = null;
    }
    setBusy(false);

    // ÐÐµÐ· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÑÐ°Ð³ Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð¼ Ð½Ðµ ÑÐ¾Ð±ÑÐ°ÑÑ â Ð½ÑÐ¶Ð½Ñ ÐÐÐ Ð¸ ÑÐµÐ»ÐµÑÐ¾Ð½.
    if (!client) return finish(clientId);

    // eGov Ð¾ÑÐ´Ð°Ð» ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼ â Ð¿ÑÐ¾Ð²ÐµÑÑÑÑ Ð½ÐµÑÐµÐ³Ð¾, Ð½Ð¾ ÑÐºÐ°Ð½ Ð¸ ÑÐ¾ÑÐ¾ Ð´Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¸ÑÑÐ¾Ð²Ð¾Ðµ
    // ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ (ÐºÐ¾Ð´ Ð¸Ð· Ð¡ÐÐ¡ ÐºÐ»Ð¸ÐµÐ½ÑÐ°), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐ°Ð³ Ð¾ÑÑÐ°ÑÑÑÑ â Ñ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑÂ».
    setScanOnly(isDocumentComplete(client));
    setCreated(client);
    setStage('document');
  };

  // ÐÐÐ Ð´Ð¾Ð¿Ð¸ÑÐ°Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð±ÑÐºÐµ â Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÐµÐ¼ ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð¸ Ð¿ÐµÑÐµÑÐ¾Ð±Ð¸ÑÐ°ÐµÐ¼ ÑÐ¾ÑÐ¼Ñ.
  const reloadDocument = async () => {
    try {
      const client = await fetchClient(created?.id);
      if (client) {
        setCreated(client);
        setDocumentVersion((prev) => prev + 1);
      }
    } catch (e) {
      // Ð½Ðµ ÑÑÑÐ°ÑÐ½Ð¾: Ð¿Ð¾Ð»Ñ Ð¾ÑÑÐ°ÑÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÐ¼ÑÐ¼Ð¸ Ð²ÑÑÑÐ½ÑÑ
    }
  };

  const saveDocument = async () => {
    const values = await documentFormRef.current.submit();
    if (!values) return;

    setBusy(true);
    try {
      await editClientDocuments({
        id: created?.id,
        document_type_id: values?.document_type_id?.value,
        document_number: values?.document_number,
        document_issuer: values?.document_issuer?.value,
        document_date: values?.document_date,
        document_date_end: values?.document_date_end,
      });
    } catch (e) {
      setBusy(false);
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°');
      return;
    }
    setBusy(false);
    finish(created?.id);
  };

  const renderCreate = () =>
    mode === 'egov' ? (
      <ClientCreatePkb onCreated={(id) => handleCreated(id, true)} onManual={() => setMode('manual')} />
    ) : (
      <>
        <span style={{ ...linkStyle, marginBottom: 16 }} role="button" onClick={() => setMode('egov')}>
          â ÐÐ¾Ð»ÑÑÐ¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ñ eGov
        </span>
        <ClientCreate
          onCreated={(id) => handleCreated(id, false)}
          hidePhoto
          hideKato={hideKato}
          hideLanguage={hideLanguage}
        />
      </>
    );

  const renderScanOnly = () => (
    <>
      <p style={{ marginBottom: 16, color: colors.dimGray }}>
        ÐÐ»Ð¸ÐµÐ½Ñ {created?.surname} {created?.name} ÑÐ¾Ð·Ð´Ð°Ð½, Ð´Ð°Ð½Ð½ÑÐµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½Ñ Ñ eGov. Ð§ÑÐ¾Ð±Ñ ÑÐºÐ°Ð½
        ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð¸ ÑÐ¾ÑÐ¾ Ð¿Ð¾Ð¿Ð°Ð»Ð¸ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð¸ Ð°Ð½ÐºÐµÑÑ ÑÐ°Ð¼Ð¸, Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÐµ ÑÐ¸ÑÑÐ¾Ð²Ð¾Ðµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ: ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð¿ÑÐ¸Ð´ÑÑ
        SMS Ñ ÐºÐ¾Ð´Ð¾Ð¼.
      </p>

      <ClientFcbDocument
        clientId={created?.id}
        iin={created?.iin}
        phone={created?.phone}
        onSuccess={() => finish(created?.id)}
      />

      <Button text="ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ" onClick={() => finish(created?.id)} />
    </>
  );

  const renderDocument = () => scanOnly ? renderScanOnly() : (
    <>
      <p style={{ marginBottom: 16, color: colors.dimGray }}>
        ÐÐ»Ð¸ÐµÐ½Ñ {created?.surname} {created?.name} ÑÐ¾Ð·Ð´Ð°Ð½. ÐÑÑÐ°Ð»Ð¾ÑÑ Ð²Ð½ÐµÑÑÐ¸ Ð´Ð°Ð½Ð½ÑÐµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ
        Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ â Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÐµ Ð¸Ñ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿Ð¾ SMS Ð¸Ð»Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð²ÑÑÑÐ½ÑÑ.
      </p>

      <ClientFcbDocument
        clientId={created?.id}
        iin={created?.iin}
        phone={created?.phone}
        onSuccess={reloadDocument}
      />

      <HookForm
        key={documentVersion}
        ref={documentFormRef}
        border
        title="ÐÐ°Ð½Ð½ÑÐµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ"
        inputs={buildDocumentInputs(created)}
        grid={{ display: 'grid', gap: 20, gridTemplateColumns: '1fr 1fr' }}
        style={{ marginBottom: 0 }}
      />

      <Button text="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ" fill onClick={saveDocument} />
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeWithCreated}
      title="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°"
      width={mode === 'manual' && stage === 'create' ? '1100px' : '720px'}
      contentStyle={{ bottom: 'auto', height: 'auto', maxHeight: '90vh' }}
    >
      {busy ? <LoaderInline /> : stage === 'document' ? renderDocument() : renderCreate()}
    </Modal>
  );
};

export default ClientCreateModal;
